import React, { useState } from "react";
import "./styles/addCredit.scss";
import "../TicketManagement/style.scss";
import "../NewMember/RoleManagmentAndPermission/style.scss";
import { createDebitCredit, geTPaybackStatus, searchUser } from "../../utils/api";
import {
  isAlphabet,
  isEmpty,
  isNumber,
  numberToWords,
} from "../../utils/common";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import searchIcon from "../../assets/images/search.svg";
import LocalLoader from "../../Components/Loader/LocalLoader";

const AddDebitCredit = () => {
  const initialValues = {
    userName: "",
    amount: "",
    remark: "",
    test: "",
  };
  const [debitCredit, setDebitCredit] = useState({ ...initialValues });
  const[transactionDate,setTransactionDate]=useState("");
  const [errors, setErrors] = useState("");
  const [selectValue, setSelectValue] = useState("DEBIT");
  const [reason, setReason] = useState("");
  const [search, setSearch] = useState({});
  const [txnInput, setTxnInput] = useState(false);
  const [txnValue, setTxnValue] = useState("");
  const [txnStatus, setTxnStatus] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  let name, value;

  const handleInput = (e, key = "") => {
    name = e.target.name;
    value = e.target.value;
    if (key === "number") {
      if (!isNumber(value) && !isEmpty(value)) return;
    } else if (key === "text") {
      if (!isAlphabet(value) && !isEmpty(value)) {
        return;
      }
    }
    if (name === "amount") {
      const regex = /^\d*\.?\d*$/;

      if (!regex.test(e.target.value)) {
        return;
      }
    }

    if (name === "userName" && value.length == 10) {
      searchUserData(value);
    }

    setDebitCredit({ ...debitCredit, [name]: value });
    setErrors((prev) => ({
      ...prev,
      userName: "",
    }));
  };

  const handleSubmit = () => {
    let error = {};
    if (isEmpty(debitCredit.amount)) {
      error.amount = "please Enter some Amount";
    }
    if (isEmpty(debitCredit.userName)) {
      error.userName = "please enter your username";
    } else if (debitCredit.userName.length < 10) {
      error.userName = "please enter 10 digit Mobile Number";
    } else {
      searchUserData(debitCredit.userName);
    }
    setErrors(error);
  };

  const searchUserData = (value) => {
    const valueRequired = true;
    setLoading(true);
    searchUser(value, valueRequired).then((resp) => {
        setLoading(false);
      if (resp?.data?.success) {
        setSearch(resp?.data?.data);

        if (
          !isEmpty(debitCredit.userName) &&
          debitCredit.userName.length === 10 &&
          !isEmpty(debitCredit.amount)
        ) {
          const params = {
            remark: debitCredit.remark,
            amount: debitCredit.amount,
            userId: debitCredit.userName,
            reason: reason,
            transactionType: selectValue,
            status: txnStatus || "SUCCESS",
            approvedBy: "",
            txnUuid: txnValue || null,
          };
          Swal.fire({
            icon: "success",
            title:
              "Are You Sure ! You Want to " +
              [selectValue] +
              " " +
              [debitCredit.amount] +
              " Rs." +
              " " +
              " " +
              "</br>" +
              "Number: " +
              [debitCredit.userName],
            // timer: 2200,
            confirmButtonColor: "#00BAF2",
            showCancelButton: true,
          }).then((resp) => {
            if (resp.isConfirmed) {
              return createDebitCredit(params).then((response) => {
                if (response?.data?.success) {
                  navigate("/DebitCreditList", { state: response?.data?.msg });
                }
              });
            }
          });
        }
      } else {
        setErrors((prev) => ({
          ...prev,
          userName: "No User Found",
        }));
        setSearch("");
      }
    });
  };

  const handleReason = (e) => {
    setReason(e.target.value);
  };




  const showtransactioninput = () =>{
    setTxnInput(!txnInput);
    if(!txnInput){
      setDebitCredit({ ...initialValues });
      setSelectValue("");
      setTxnStatus("");
      setTxnValue("");
      setTransactionDate("");
    }
  }

  const paybackStatus = () =>{
    if(txnValue !== ""){
      setLoading(true);
       geTPaybackStatus(txnValue).then((resp) =>{
        setLoading(false);
           if(resp?.data?.success){
            console.log("user",resp?.data)
            if(resp?.data?.data?.txnStatus){
              const data ={
                userName: resp?.data?.data?.userId,
                amount: resp?.data?.data?.transactionAmout,
                remark: resp?.data?.data?.remarks,
                test: "",
              }
              searchUserData(resp?.data?.data?.userId);
              setTxnStatus(resp?.data?.data?.txnStatus);
              setDebitCredit(data);
              setTransactionDate(resp?.data?.data?.createdDate);
              setSelectValue(resp?.data?.data?.transactionType);
            }else{
              Swal.fire({
                icon: "success",
                title:"This transaction is " +resp?.data?.data?.txnStatus,
                
                confirmButtonColor: "#00BAF2",
                showCancelButton: true,
              })
              // .then((res) => {
              //   setDebitCredit({ ...initialValues });
              //   setSelectValue("")
              //   setTxnStatus("");
              //   setTxnInput(false);
              //    setTxnValue("");
              // });
            }
       
           
           }
      }).catch((err) =>{
         setLoading(false);
      });
    }
    
  } 

  console.log("date",transactionDate);


  return (
    <>
     {loading && <LocalLoader className="tableLoader" />}
      <div className="subadmin_main_container">
        <div
          className="subadmin_head flex space-between"
          style={{ width: "97%" }}
        >
          <strong>Debit/Credit</strong>
        </div>

        <div className="subadmin_container">
          <div className="">
            <div className="pd-30"> 
               {!isEmpty(search) && debitCredit.userName.length === 10 && (
                   <div className="flex form-container mg_top17">
                    <div className="flex form-container mg_top17 " style={{flexGrow:1}}>
                      <lable className=" flex column fs-12 " style={{flex:"1 1 50%",maxWidth:"250px"}}>
                        Name:
                        <span className="blue_font fw-bold">
                          {search.firstName + " " + search.lastName}
                        </span>
                      </lable>
                      {/* <label className="profile ml-15"></label> */}
                      <lable className="fs-12 flex column" style={{flex:"1 1 50%",maxWidth:"250px"}}>
                        User Wallet Balance:
                        <span className=" fw-bold blue_font ml-5">
                          ₹ {search.mainBalance}
                        </span>
                      </lable>
                    </div>
                     </div>
                  )}
            <div className="flex form-container mg_top17">
              
              <div>
                <lable className="filter_text fs">UserName</lable>
                <div className="flex align-items form-container">
                  <div className="mg-top3">
                    <div className="mg-top3">
                      <input
                        type="text"
                        name="userName"
                        value={debitCredit.userName}
                        className="filter_select  fs"
                        placeholder="Enter Mobile Number"
                        onChange={(e) => handleInput(e, "number")}
                        maxLength={10}
                        disabled={txnInput}
                      ></input>
                    </div>
                    {errors.userName && (
                      <p className="error fs-12 mt-10">{errors.userName}</p>
                    )}
                  </div>
                  {/* {!isEmpty(search) && debitCredit.userName.length === 10 && (
                    <div className="flex row">
                      <lable className=" flex column fs-12 ">
                        Name:
                        <span className="blue_font fw-bold">
                          {search.firstName + " " + search.lastName}
                        </span>
                      </lable>
                      <label className="profile ml-15"></label>
                      <lable className="fs-12 flex column ml-15">
                        User Wallet Balance:
                        <span className=" fw-bold blue_font ml-5">
                          ₹ {search.mainBalance}
                        </span>
                      </lable>
                    </div>
                  )} */}
                
                </div>
              </div>

           { txnInput &&   <div>
                <lable className="filter_text fs">Date and Time</lable>
                <div className="flex align-items form-container">
                  <div className="mg-top3">
                    <div className="mg-top3">
                      <input
                        type="text"
                        name="userName"
                        value={transactionDate?.split('.')[0].replace('T', ' ')}
                        className="filter_select  fs"
                        placeholder="Date & Time"
                        onChange={(e) => handleInput(e, "number")}
                        maxLength={10}
                        disabled={txnInput}
                      ></input>
                    </div>
                    {/* {errors.userName && (
                      <p className="error fs-12 mt-10">{errors.userName}</p>
                    )} */}
                  </div>
                
                </div>
              </div>
            }
              </div>
              
                
              
              <div style={{ maxWidth: "fit-content" }}>
                <div className="flex form-container mg_top17">
                  <div>
                    <lable className="filter_text fs">Transaction Mode:</lable>
                    <div className="mg-top3">
                      <select
                        defaultValue="DEBIT"
                        className="filter_select fs  pd-10"
                        disabled={txnInput}
                      >
                        <option>TRANSACTION Mode</option>
                        <option selected value="DEBIT">
                          NET BANKING
                        </option>
                        <option value="CREDIT">CASH</option>
                        <option value="CREDIT">CARD PAYMENT</option>
                        <option value="CREDIT">CREDIT LIMIT</option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <lable className="filter_text fs">Transaction Type</lable>
                    <div className="mg-top3 ">
                      <select
                        onChange={(e) => setSelectValue(e.target.value)}
                        className="filter_select fs pd-10"
                     
                        value={selectValue}
                      >
                        <option value={null} disabled selected>
                          TRANSACTION TYPE
                        </option>
                        <option value="DEBIT">DEBIT</option>
                        <option value="CREDIT">CREDIT</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="flex form-container mg_top17">
                  <div className="flex gap-20">
                    <div className="m">
                      <lable className="filter_text fs">Select Reason</lable>
                      <div className="mg-top3">
                        <select
                          onChange={handleReason}
                          className="filter_select fs  pd-10"
                          disabled={txnInput}
                        >
                          <option disabled selected>
                            SELECT REASON
                          </option>
                          <option>SETTLEMENT CREDIT</option>
                          <option>SETTLEMENT DEBIT</option>
                          <option>DISPUTE</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="flex gap-20">
                    <div style={{maxWidth:"250px"}} >
                      <lable className="filter_text fs">Amount</lable>
                      <div className="mg-top3">
                        <input
                          type="text"
                          name="amount"
                          value={debitCredit.amount}
                          onChange={(e) => handleInput(e)}
                          className="filter_select fs"
                          maxLength={6}
                          disabled={txnInput}
                        ></input>
                      </div>
                      {errors.amount && (
                        <p className="error fs-12 mt-10">{errors.amount}</p>
                      )}
                    </div>
                  </div>
                 
                </div>
                 <div className="flex justify-end">
 <label className="fw-500 fs-12" style={{marginTop:"4px"}}>
                        {numberToWords(debitCredit.amount)}
                      </label>
                  </div>
                <div className="flex form-container mg_top17">
                <div className="flex gap-10" style={{alignItems:"center",flex:"1 1 50%"}}>
                  <input type="checkbox" id="checkbox" name="" checked={txnInput}  onClick={showtransactioninput} />
                  <label htmlFor="checkbox" className="fs ">IS PAYBACK FOR REFUND?</label>
                 </div>
                 {<div>
                <lable className="filter_text fs">Transaction Id</lable>
                <div className="flex align-items form-container">
                  <div className="mg-top3 ">
                    <div className="mg-top3" style={{position:"relative", }}>
                      <input
                        type="text"
                        name="txnId"
                        value={txnValue}
                        className="filter_select  fs"
                        placeholder="Enter Transaction Id"
                        disabled={!txnInput}
                        onChange={(e) =>setTxnValue(e.target.value)}
                      ></input>
                        <div className="searchImg searchButton center" onClick={paybackStatus}
                        style={{
                          position:"absolute",
                          right:"0px",
                          bottom:"0",top:"0", borderRadius:"0 8px 8px 0"
                          
                        }}
                        >
                      <img src={searchIcon} alt="search" style={{width:"24px"}} />
                      </div>
                    </div>
                  
                    {errors.txnValue && (
                      <p className="error fs-12 mt-10">{errors.txnValue}</p>
                    )}
                  </div>

                </div>
              </div>}
                </div>
                
              
                 <div>
                  <lable className="filter_text fs">Remark</lable>
                  <div className="mg-top3">
                    <input
                      name="remark"
                      value={debitCredit.remark}
                      onChange={(e) => handleInput(e, "")}
                      type="text"
                      className="filter_select"
                      style={{ width: "100%" }}
                   
                    ></input>
                  </div>
                </div>
                <div>
                  <button
                    onClick={handleSubmit}
                    style={{
                      width: "100%",
                      height: "45px",
                      marginTop: "25px",
                      marginBottom: "20px",
                    }}
                    className="userlist_btn"
                  >
                    {txnStatus === "PENDING"?"Request Payback":"Add/DEBIT OR CREDIT"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddDebitCredit;
